import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

import protectRoute from '../hoc/protectRoute'
import { rootRoute } from './root'

const VipCenter = lazyRouteComponent(() => import('../pages/vip-center'))

// Sub-screen shown within the VIP Center. `card` is FE-01; `experience` and
// `bonus` are the FE-03 / bonus-details subpages reached from the card header.
export type VipCenterView = 'card' | 'experience' | 'bonus'

type VipCenterSearch = {
  view: VipCenterView
}

export const vipCenterRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: 'vip-center',
  component: protectRoute(VipCenter, true),
  validateSearch: (search: Record<string, unknown>): VipCenterSearch => ({
    view:
      search.view === 'experience' || search.view === 'bonus'
        ? search.view
        : 'card',
  }),
})
